import { Component } from '@angular/core';

@Component({
    selector: 'app-have-question',
    imports: [],
    templateUrl: './have-question.html',
    styleUrl: './have-question.scss',
})
export class HaveQuestion {}
